import React from "react";
import { Box, Typography } from "@mui/material";
import { useParams, Link } from "react-router-dom";
import PrivacyIcon from "@mui/icons-material/PrivacyTip";

function PrivacyPolicy() {
  const { lang } = useParams();

  const texts = {
    en: {
      mainTitle: "Privacy Policy",
      userTitle: "User Privacy",
      advertTitle: "Advertising",
      contactTitle: "Contact Details",
      prefsTitle: "User Preferences",
      questionsTitle: "Questions or Concerns",

      userText:
        "Pintative Ltd is fully committed to respecting your privacy. We do not collect or use any of your personal data.\nOur website does not use cookies.",
      advertText:
        "Neither our website nor our applications display or utilize any form of advertising.\nAll commercial transactions, including purchases, are exclusively handled by Apple App Store services.",
      contactText:
        "Support and inquiries through our website or the Pinta Pro app are handled via email. Messages are deleted as soon as the support or inquiry is resolved. In-app user preferences and content created by users are stored solely on their device and iCloud account.",
      prefsText:
        "Cloud services providing templates may automatically collect limited connection details, such as IP address and geographical location, for statistical, performance, and consumption purposes.",
      questionsText:
        "If you have questions about data protection or need assistance resolving any issues with your personal data, you can contact us using the {link} available on our website.",
      linkText: "contact form",
      contactPath: "/en/contact",
    },
    es: {
      mainTitle: "Política de Privacidad",
      userTitle: "Privacidad del Usuario",
      advertTitle: "Publicidad",
      contactTitle: "Detalles de Contacto",
      prefsTitle: "Preferencias del Usuario",
      questionsTitle: "Preguntas o Dudas",

      userText:
        "Pintative Ltd está plenamente comprometida con el respeto a tu privacidad. No recopilamos ni utilizamos ningún tipo de datos personales. Nuestra página web no utiliza cookies.",
      advertText:
        "Ni nuestra página web ni nuestras aplicaciones muestran o utilizan ningún tipo de publicidad. Todas las transacciones comerciales, incluidas las compras, son gestionadas exclusivamente por los servicios de Apple App Store.",
      contactText:
        "El soporte y las consultas a través de nuestra página web o la aplicación Pinta Pro se gestionan por correo electrónico. Los mensajes se eliminan tan pronto como se resuelve el soporte o la consulta. Las preferencias de usuario y el contenido creado en la aplicación se almacenan exclusivamente en el dispositivo y en la cuenta de iCloud del usuario.",
      prefsText:
        "Los servicios en la nube que proporcionan plantillas pueden recopilar automáticamente detalles limitados de conexión, como la dirección IP y la ubicación geográfica, con fines estadísticos, de rendimiento y de consumo.",
      questionsText:
        "Si tienes preguntas sobre la protección de datos o necesitas ayuda para resolver cualquier problema relacionado con tus datos personales, puedes ponerte en contacto con nosotros a través del {link} disponible en nuestra página web.",
      linkText: "formulario de contacto",
      contactPath: "/es/contact",
    },
    fr: {
      mainTitle: "Politique de Confidentialité",
      userTitle: "Vie Privée de l’Utilisateur",
      advertTitle: "Publicité",
      contactTitle: "Détails de Contact",
      prefsTitle: "Préférences de l’Utilisateur",
      questionsTitle: "Questions ou Doutes",

      userText:
        "Pintative Ltd s’engage pleinement à respecter votre vie privée. Nous ne recueillons ni n’utilisons aucune donnée personnelle. Notre site web n’utilise pas de cookies.",
      advertText:
        "Ni notre site web ni nos applications n’affichent de publicité. Toutes les transactions commerciales, y compris les achats, sont exclusivement gérées par l’Apple App Store.",
      contactText:
        "Le support et les demandes via notre site web ou l’application Pinta Pro sont gérés par e-mail. Les messages sont supprimés dès que l’assistance ou la demande est résolue. Les préférences d’utilisateur et le contenu créé dans l’application sont stockés uniquement sur l’appareil et sur le compte iCloud de l’utilisateur.",
      prefsText:
        "Les services cloud qui fournissent des modèles peuvent collecter automatiquement des informations de connexion limitées (adresse IP, localisation géographique) à des fins statistiques, de performance et de consommation.",
      questionsText:
        "Si vous avez des questions concernant la protection des données ou si vous avez besoin d’aide pour résoudre tout problème lié à vos données personnelles, vous pouvez nous contacter via le {link} sur notre site web.",
      linkText: "formulaire de contact",
      contactPath: "/fr/contact",
    },
    de: {
      mainTitle: "Datenschutzerklärung",
      userTitle: "Benutzerdatenschutz",
      advertTitle: "Werbung",
      contactTitle: "Kontaktdetails",
      prefsTitle: "Benutzereinstellungen",
      questionsTitle: "Fragen oder Bedenken",

      userText:
        "Pintative Ltd ist fest entschlossen, Ihre Privatsphäre zu respektieren. Wir sammeln oder verwenden keine personenbezogenen Daten. Unsere Website verwendet keine Cookies.",
      advertText:
        "Weder unsere Website noch unsere Anwendungen zeigen Werbung an. Alle kommerziellen Transaktionen, einschließlich Käufe, werden ausschließlich vom Apple App Store verwaltet.",
      contactText:
        "Support und Anfragen über unsere Website oder die Pinta Pro-App werden per E-Mail abgewickelt. Nachrichten werden gelöscht, sobald die Unterstützung oder Anfrage abgeschlossen ist. Benutzereinstellungen und vom Benutzer erstellte Inhalte in der App werden ausschließlich auf dem Gerät und im iCloud-Konto des Benutzers gespeichert.",
      prefsText:
        "Cloud-Dienste, die Vorlagen bereitstellen, können automatisch begrenzte Verbindungsdetails (z. B. IP-Adresse und geografischer Standort) zu statistischen Zwecken sowie für Leistung und Verbrauch erfassen.",
      questionsText:
        "Wenn Sie Fragen zum Datenschutz haben oder Hilfe bei der Lösung von Problemen mit Ihren personenbezogenen Daten benötigen, können Sie uns über das {link} auf unserer Website kontaktieren.",
      linkText: "Kontaktformular",
      contactPath: "/de/contact",
    },
    it: {
      mainTitle: "Informativa sulla Privacy",
      userTitle: "Privacy dell’Utente",
      advertTitle: "Pubblicità",
      contactTitle: "Dettagli di Contatto",
      prefsTitle: "Preferenze dell’Utente",
      questionsTitle: "Domande o Preoccupazioni",

      userText:
        "Pintative Ltd è pienamente impegnata a rispettare la tua privacy. Non raccogliamo o utilizziamo alcun dato personale. Il nostro sito web non utilizza cookie.",
      advertText:
        "Né il nostro sito web né le nostre applicazioni mostrano o utilizzano alcuna forma di pubblicità. Tutte le transazioni commerciali, incluse le acquisti, sono gestite esclusivamente dai servizi Apple App Store.",
      contactText:
        "Il supporto e le richieste attraverso il nostro sito web o l’app Pinta Pro sono gestiti via email. I messaggi vengono eliminati non appena il supporto o la richiesta viene risolta. Le preferenze utente e i contenuti creati dagli utenti nell’app sono archiviati esclusivamente sul dispositivo e sull’account iCloud dell’utente.",
      prefsText:
        "I servizi cloud che forniscono modelli possono raccogliere automaticamente dettagli limitati di connessione, come indirizzo IP e posizione geografica, per scopi statistici, di performance e di consumo.",
      questionsText:
        "Se hai domande sulla protezione dei dati o hai bisogno di aiuto per risolvere eventuali problemi relativi ai tuoi dati personali, puoi contattarci utilizzando il {link} disponibile sul nostro sito web.",
      linkText: "modulo di contatto",
      contactPath: "/it/contact",
    },
  };

  const t = texts[lang] || texts.en;

  return (
    <Box sx={{ maxWidth: "800px", mx: "auto", p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        <PrivacyIcon sx={{ mr: 1 }} />
        {t.mainTitle}
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
        {t.userTitle}
      </Typography>
      <Typography variant="body1" paragraph>
        {t.userText}
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom>
        {t.advertTitle}
      </Typography>
      <Typography variant="body1" paragraph>
        {t.advertText}
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom>
        {t.contactTitle}
      </Typography>
      <Typography variant="body1" paragraph>
        {t.contactText}
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom>
        {t.prefsTitle}
      </Typography>
      <Typography variant="body1" paragraph>
        {t.prefsText}
      </Typography>

      <Typography variant="h5" component="h2" gutterBottom>
        {t.questionsTitle}
      </Typography>
      <Typography variant="body1" paragraph>
        {t.questionsText.split("{link}").map((part, index) =>
          index === 0 ? (
            part
          ) : (
            <Link
              key={index}
              to={t.contactPath}
              style={{ color: "inherit", textDecoration: "underline" }}
            >
              {t.linkText}
            </Link>
          ),
        )}
      </Typography>
    </Box>
  );
}

export default PrivacyPolicy;
